export const checkAPIError = (errorList: (Error | undefined)[]) => {
  return (
    errorList.filter((error) => error && error.message.includes('Forbidden'))
      .length > 0
  );
};
